import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { isPlatform } from '@ionic/angular';
import Env from '@ridango/core/env';

@Injectable()
export class ExternalRedirectGuard implements CanActivate {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject('ENV') private env: Env,
        private localizeRouterService: LocalizeRouterService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const externalRedirects = this.env.EXTERNAL_REDIRECTS;
        if (!externalRedirects) return true;
        const pathName = '/' + route.pathFromRoot.flatMap(({ url }) => url.map(({ path }) => path)).join('/');
        const redirectableRoute = Object.keys(externalRedirects).find(
            (path) => this.localizeRouterService.translateRoute(path) === pathName
        );
        if (!redirectableRoute) return true;
        const [, url] =
            externalRedirects[redirectableRoute].find(([platform]) => platform === '*' || isPlatform(platform)) ?? [];
        if (!url) return true;
        this.document.location.href = url;
        return false;
    }
}
